import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Header, Form, Button, Message, Confirm} from 'semantic-ui-react'
import * as Venue from '../../store/Venue';
function toGeocode(address, city, state, zip) {
    return [
        address,
        city,
        state,
        zip
    ].join(', ').replace(/ /g, '+');
}
class EditVenue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            showDeleteConfirmation: false
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onAddressChange = this.onAddressChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCancelDelete = this.onCancelDelete.bind(this);
        this.onConfirmDelete = this.onConfirmDelete.bind(this);
    }
    
    onChange(e, {name, value}){
        const {venue, actions} = this.props;
        actions.updateEditVenue({...venue, [name]:value});
    }

    async onAddressChange(e) {
        const {actions, venue} = this.props;
        const {address, city, state, zip} = venue;
        const urlAddress = `/api/geo?address=${toGeocode(address, city, state, zip)}`;
        const response = await fetch(urlAddress);
        const geoResult = await response.json();
        if (geoResult.status === 'OK'){
            console.log(geoResult);
            const {geometry} = geoResult.results[0];
            actions.updateEditVenue({...venue, ...geometry.location});
            // this.setState({...geometry.location});
        }
    }

    async onSubmit(e) {
        const {venue, actions} = this.props;
        try {
            await actions.updateVenue(venue);
            actions.replace('/admin');
        } catch (error) {
            this.setState({error: error.message});
        }
    }

    async onDelete(e){
        e.preventDefault();
        const {venue, actions} = this.props;
        try {
            await actions.deleteVenue(venue);
            actions.replace('/admin');
            this.setState({showDeleteConfirmation: false});
        } catch (error) {
            this.setState({error: error.message, showDeleteConfirmation: false});
            window.scrollTo(0, 0);
        }
    }

    onConfirmDelete(e){
        e.preventDefault();
        this.setState({showDeleteConfirmation: true});
    }

    onCancelDelete(e){
        e.preventDefault();
        this.setState({showDeleteConfirmation: false});
    }

    render() {
        const {venue} = this.props;
        const {error, showDeleteConfirmation} = this.state;
        return (
            <div className='venue'>
                <Confirm header="Delete Venue" confirmButton="Delete" open={showDeleteConfirmation} onCancel={this.onCancelDelete} onConfirm={this.onDelete} content="Are you sure you want to delete this venue?" />
                <Header as='h1' content="Edit Venue" />
                {venue ? <Form onSubmit={this.onSubmit} error>
                    <Message error content={error} />
                        <Form.Input name='name' label='Name' value={venue.name} placeholder='Name' onChange={this.onChange} />
                        <Form.Input name='address' label='Address' placeholder='Address' value={venue.address} onChange={this.onChange} onBlur={this.onAddressChange} />
                        <Form.Group>
                            <Form.Input width={11} name='city' label='City' placeholder='City' value={venue.city} onChange={this.onChange} onBlur={this.onAddressChange} />
                            <Form.Input width={3} name='state' label='State' placeholder='State' value={venue.state} maxLength='2' onChange={this.onChange} onBlur={this.onAddressChange} />
                            <Form.Input width={4} name='zip' label='Zip Code' placeholder='Zip Code' value={venue.zip} onChange={this.onChange} onBlur={this.onAddressChange} />
                        </Form.Group>
                    <Button primary content='Save' disabled={!(venue.lat && venue.lng)} />
                    <Button negative floated="right" content="Delete Venue" type="button" onClick={this.onConfirmDelete} />
                </Form> : venue}
            </div>
        );
    }
}

EditVenue.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        venue: Venue.selector(state).venue[ownProps.match.params.venueId],
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Venue.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditVenue));